import React from "react";

export const Team = () => {
  return (
    <div id="atendimento-24h" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Atendimento 24 Horas</h2>
          <p>
            Suporte técnico disponível 24 horas por dia para emergências em
            sistemas de bombeamento, instalações hidráulicas e automação.
          </p>
        </div>

        <div className="row">
          <div className="col-md-4 col-sm-6">
            <div className="service-box">
              <i className="fa fa-clock-o fa-3x"></i>
              <h4>Disponibilidade Total</h4>
              <p>
                Atendimento emergencial a qualquer hora, inclusive finais de
                semana e feriados.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="service-box">
              <i className="fa fa-wrench fa-3x"></i>
              <h4>Emergências Técnicas</h4>
              <p>
                Suporte rápido para falhas em motobombas, boias, quadros de
                comando e sistemas automatizados.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="service-box">
              <i className="fa fa-whatsapp fa-3x"></i>
              <h4>Contato Imediato</h4>
              <p>
                Chame no WhatsApp e receba atendimento rápido e eficiente.
              </p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
